import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import { remCalc } from '../utilities/style-util';

const Loading = ({
  classes,
  size,
  extraStyle = {},
  containerStyle = {},
}) => (
  <div className={classes.container} style={containerStyle}>
    <CircularProgress
      className={classes.inProgress}
      size={size || 80}
      style={extraStyle}
      color="inherit"
    />
  </div>
);

const styles = {
  container: {
    textAlign: 'center',
    fontSize: remCalc(65),
  },
  inProgress: {
    margin: remCalc(32),
  },
};

Loading.propTypes = {
  classes: PropTypes.object.isRequired,
  size: PropTypes.number,
  extraStyle: PropTypes.object,
  containerStyle: PropTypes.object,
};

export default withStyles(styles)(Loading);
